export class ClientModel {
  clientId: number;
  clientName: string;
}
